// @flow

import { type Merchant } from './types';

export function getMerchantLogo(merchant: Merchant): string {
  return merchant['logo'];
}
